import { combine, createStore, sample } from 'effector';
// Cross-entity auth state is consumed through the auth slice public API.
// eslint-disable-next-line local/no-same-layer-slice-alias-imports
import { getMeFx } from '~/entities/auth';
import { type BanksMap } from './banks-map';
import { initializeBanks } from './initializeBanks';
import { initializeBanksFx } from './initializeBanksFx';

const $hasSuccessfulGetMe = createStore(false).on(getMeFx.done, () => true);
const $banksInitializationStarted = createStore(false).on(initializeBanksFx, () => true);

export const $banksMap = createStore<BanksMap>(new Map()).on(initializeBanksFx.doneData, (_, banks) => banks);
export const $banksError = createStore<Error | null>(null)
    .on(initializeBanksFx, () => null)
    .on(initializeBanksFx.failData, (_, error) => error);

sample({
    clock: getMeFx.done,
    target: initializeBanks,
});

sample({
    clock: initializeBanks,
    source: combine({
        hasSuccessfulGetMe: $hasSuccessfulGetMe,
        started: $banksInitializationStarted,
    }),
    filter: ({ hasSuccessfulGetMe, started }) => hasSuccessfulGetMe && !started,
    fn: () => undefined,
    target: initializeBanksFx,
});
